export default {
  ADD_EXHIBITOR: 'Añadir expositor',
  NO_EXHIBITOR: 'Aún no ha añadido ningún expositor.',
  EXHIBITOR_NAME: 'Nombre del expositor',
  EXHIBITOR_EMAIL: 'Correo del expositor',
  EXHIBITOR_CONTACT: 'Contacto del expositor',
  CITY: 'Ciudad',
  COUNTRY: 'País',
  ADDRESS: 'Dirección',
  ORGANISATION: 'Organización',
  TRANSACTION_ID: 'Id de transacción',
  DATE_OF_PURCHASE: 'Fecha de compra',
  DEVICES_COUNT: 'Conteo de dispositivos',
  ADD_EXHIBITOR_SUCCESS: 'Su perfil de expositor se ha configurado correctamente!',
  LICENSE_DETAILS: 'Detalles de la licencia',
  UPDATE_EXHIBITOR_SUCCESS: 'Su perfil de expositor se ha actualizado correctamente!',
  EDIT_EXHIBITOR: 'Editar expositor'
}
